import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
const $Ref = (_1, _2) => ({tag: "Ref", _1, _2});
const Ref = value0 => value1 => $Ref(value0, value1);
const value = v => v._1;
const refValue = value;
const read = dictMonadEffect => v => Specular$dFRP$dBase.readDynamic(dictMonadEffect)(v._1);
const readRef = dictMonadEffect => read(dictMonadEffect);
const pureFocusRef = lens => v => $Ref(Specular$dFRP$dBase.functorDynamic.map(lens.get)(v._1), x => v._2(s => lens.set(s)(x(lens.get(s)))));
const previewRef = prism => v => $Ref(
  Specular$dFRP$dBase.functorDynamic.map(prism.preview)(v._1),
  x => v._2(s => {
    const v1 = x(prism.preview(s));
    if (v1.tag === "Just") { return prism.review(v1._1); }
    return s;
  })
);
const newWithEvent = dictMonadFRP => {
  const MonadCleanup1 = dictMonadFRP.MonadCleanup1();
  const Monad0 = MonadCleanup1.Monad0();
  const Bind1 = Monad0.Bind1();
  const MonadEffect0 = dictMonadFRP.MonadEffect0();
  const subscribeEvent_ = Specular$dFRP$dBase.subscribeNode(MonadEffect0)(MonadCleanup1);
  const pure2 = Monad0.Applicative0().pure;
  return initial => extraUpdate => Bind1.bind(Specular$dFRP$dBase.newDynamic(MonadEffect0)(initial))(v => {
    const $0 = v.dynamic;
    const $1 = v.modify;
    return Bind1.bind(subscribeEvent_($1)(extraUpdate))(() => pure2($Ref($0, $1)));
  });
};
const newRefWithEvent = dictMonadFRP => newWithEvent(dictMonadFRP);
const $$new = dictMonadEffect => {
  const Monad0 = dictMonadEffect.Monad0();
  const bind1 = Monad0.Bind1().bind;
  const pure2 = Monad0.Applicative0().pure;
  return initial => bind1(Specular$dFRP$dBase.newDynamic(dictMonadEffect)(initial))(v => pure2($Ref(v.dynamic, v.modify)));
};
const newRef = dictMonadEffect => $$new(dictMonadEffect);
const modify = dictMonadEffect => v => x => dictMonadEffect.liftEffect(v._2(x));
const refUpdate = dictMonadEffect => v => x => dictMonadEffect.liftEffect(v._2(x));
const write = dictMonadEffect => r => x => dictMonadEffect.liftEffect(r._2(_old => x));
const refUpdateConst = dictMonadEffect => r => x => dictMonadEffect.liftEffect(r._2(_old => x));
const $$set = dictMonadEffect => r => x => dictMonadEffect.liftEffect(r._2(_old => x));
const wrapViewWidget = dictMonadWidget => {
  const MonadCleanup1 = dictMonadWidget.MonadReplace2().MonadCleanup1();
  const bind1 = MonadCleanup1.Monad0().Bind1().bind;
  const subscribeEvent_ = Specular$dFRP$dBase.subscribeNode(dictMonadWidget.MonadFRP1().MonadEffect0())(MonadCleanup1);
  return widget => v => bind1(widget(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(v._1)))(updateE => subscribeEvent_(x => v._2(_old => x))(updateE));
};
const updateRef = dictMonadEffect => r => x => dictMonadEffect.liftEffect(r._2(_old => x));
const invariantRef = {imap: f => g => v => $Ref(Specular$dFRP$dBase.functorDynamic.map(f)(v._1), x => v._2(x$1 => g(x(f(x$1)))))};
const focusRef = lensD => v => $Ref(
  Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v1 => v1.get)(lensD))(v._1),
  x => {
    const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(Specular$dFRP$dBase.functorDynamic.map(lens => modify_a => s => lens.set(s)(modify_a(lens.get(s))))(lensD));
    return () => {
      const f = $0();
      return v._2(f(x))();
    };
  }
);
const $$const = x => $Ref(
  (() => {
    const n = Specular$dInternal$dIncremental.constant(x);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })(),
  v => () => {}
);
const constRef = $$const;
export {
  $Ref,
  Ref,
  $$const as const,
  constRef,
  focusRef,
  invariantRef,
  modify,
  $$new as new,
  newRef,
  newRefWithEvent,
  newWithEvent,
  previewRef,
  pureFocusRef,
  read,
  readRef,
  refUpdate,
  refUpdateConst,
  refValue,
  $$set as set,
  updateRef,
  value,
  wrapViewWidget,
  write
};
